module.exports = __webpack_public_path__ + "img/icon-filtro.98be8684.svg";